import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './card-list.scss';

/*
  Allows us to stop repeating ourselves when making card lists:

  <CardList>
    <CardListItem>
      <h2>This is a card</h2>
    </CardListItem>
    <CardListItem>
      <div>
        <h2>This is also a card</h2>
        <div>
          <h3>With addmittedly, more stuff<h3>
        </div>
      </div>
    </CardListItem>
  </CardList>
*/

export class CardList extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    wrap: PropTypes.bool
  };

  render() {
    return (
      <div
        className={classnames('card-list', this.props.className, {
          'card-list--wrap': this.props.wrap
        })}
      >
        {this.props.children}
      </div>
    );
  }
}

/*
  Wraps its own children in an appropriate class to use with the card-list
*/
export class CardListItem extends React.Component {
  static propTypes = {
    className: PropTypes.string
  };

  render() {
    return (
      <div className={classnames('card-list__item', this.props.className)}>
        {this.props.children}
      </div>
    );
  }
}
